import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TwoFaComingSoonPopup, TwoFaOptInAvailablePopup } from './two-fa-new-feature-popups';
export var TwoFaPopups = function () {
    return (_jsxs(_Fragment, { children: [_jsx(TwoFaComingSoonPopup, {}), _jsx(TwoFaOptInAvailablePopup, {})] }));
};
